import { useGetAppointmentType } from 'api/AppointmentTypes'
import { useGetAreaBookingType } from 'api/AreaBookingTypes'
import { useGetCourseType } from 'api/CourseTypes'
import { useGetHotelRoomType } from 'api/HotelRoomTypes'
import { useGetPackage } from 'api/Packages'
import { useGetProduct } from 'api/Products'
import { useSessionType } from 'api/SessionTypes'
import { useGetTableReservationType } from 'api/TableReservationTypes'
import { useGetVoucherType } from 'api/VoucherTypes'
import { OfferingSummaryTypeEnum as OfferingType } from '@trybeapp/sdk'

export const useOffering = (offeringId: string, offeringType: OfferingType) => {
  let query

  switch (offeringType) {
    default:
    case OfferingType.Appointment:
      query = useGetAppointmentType
      break
    case OfferingType.AreaBooking:
      query = useGetAreaBookingType
      break
    case OfferingType.Course:
      query = useGetCourseType
      break
    case OfferingType.Package:
      query = useGetPackage
      break
    case OfferingType.Product:
      query = useGetProduct
      break
    case OfferingType.TableReservation:
      query = useGetTableReservationType
      break
    case OfferingType.HotelRoomReservation:
      query = useGetHotelRoomType
      break
    case OfferingType.Session:
      query = useSessionType
      break
    case OfferingType.Voucher:
      query = useGetVoucherType
      break
  }

  const queryResult = query(offeringId)

  const { data: { data: offering } = {} } = queryResult

  return { offering, ...queryResult }
}
